import React, { useState } from 'react';

import {
  render
} from '../renderer/renderer';
import './Renderer.scss';

function initiateWorker() {
  const worker = new Worker(new URL('../renderer/worker', import.meta.url));
  worker.postMessage({
    question:
      'hello from worker',
  });
  worker.onmessage = ({ data: { response } }) => {
    console.log(response);
  };
  return worker;
}

function Renderer(props: {
  title: string;
  config: BoatConfig;
  selectedConfig: SelectedConfig;
  rendererConfig: RendererConfig;
  skipBase?: boolean;
  widthOverride?: number;
  heightOverride?: number;
  onRender?: (image: string) => void;
  renderingMode?: 'default'|'alternate';
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [zoom, setZoom] = React.useState(false);
  const baseCanvas = React.useRef<HTMLCanvasElement|null>(null);
  const bottomCanvas = React.useRef<HTMLCanvasElement|null>(null);
  const middleCanvas = React.useRef<HTMLCanvasElement|null>(null);
  const finalCanvas = React.useRef<HTMLCanvasElement|null>(null);

  const worker = React.useRef<Worker|undefined>(undefined);

  const runRenderer = async () => {
    if (!baseCanvas.current || !bottomCanvas.current || !middleCanvas.current || !finalCanvas.current) return;
    setIsLoading(true);
    const finalImage = await render(
      baseCanvas.current,
      middleCanvas.current,
      bottomCanvas.current,
      finalCanvas.current,
      props.config,
      props.selectedConfig,
      props.rendererConfig,
      props.skipBase,
      props.widthOverride,
      props.heightOverride,
      props.renderingMode
    );
    setIsLoading(false);

    if (props.onRender) props.onRender(finalImage);
  }

  React.useEffect(() => {
    runRenderer();
  }, [props.config, props.rendererConfig]);

  return (
    <div className="Renderer">
      <div>Renderer: {props.title} {isLoading && <span>Loading...</span>}</div>
      <div className="canvas-container">
        <canvas ref={baseCanvas} style={{display: 'none'}} />
        <canvas ref={middleCanvas} style={{display: 'none'}} />
        <canvas ref={bottomCanvas} style={{display: 'none'}} />
      </div>
      <div className='canvas-container'>
        <canvas className={zoom ? 'fullsize' : ''} ref={finalCanvas} onClick={() => setZoom(!zoom)} style={{cursor: 'pointer'}} />
      </div>

      <div>
        <button onClick={() => runRenderer()}>Render</button>
      </div>
    </div>
  );
}

export { Renderer };
